module.exports = __webpack_public_path__ + "media/app/assets/modal-background-3dbd2374cbc9b5ae4998a88224f63f91.png";